import React, { FC, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import LoadingWithoutModal from "components/common/LoadingWithoutModal";
import Acquirer from "enums/Acquirer";
import { SetupProps } from "./types";

type SetupComponent = React.LazyExoticComponent<React.FC<SetupProps>>;

const registry: Partial<Record<Acquirer, SetupComponent>> = {
  [Acquirer.STRIPE]: React.lazy(() => import("./stripe/StripeSetupProvider")),
};

const AcquirerSetup: FC<SetupProps> = (props) => {
  const { t } = useTranslation();
  const Setup = registry[props.session.acquirer];

  if (!Setup) {
    return (
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        {t("checkout.UnavailableMessage")}
      </Typography>
    );
  }

  return (
    <Suspense fallback={<LoadingWithoutModal open />}>
      <Setup {...props} />
    </Suspense>
  );
};

export default AcquirerSetup;
